import { render, staticRenderFns } from "./CreateWeetUploadStep.vue?vue&type=template&id=2bed92ca&scoped=true"
import script from "./CreateWeetUploadStep.vue?vue&type=script&lang=ts"
export * from "./CreateWeetUploadStep.vue?vue&type=script&lang=ts"
import style0 from "./CreateWeetUploadStep.vue?vue&type=style&index=0&id=2bed92ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed92ca",
  null
  
)

export default component.exports